import { useQuery } from "@apollo/client/react";
import { getMainDefinition } from "@apollo/client/utilities";
import { useClerk } from "@clerk/clerk-react";

import { usePendingSession } from "@/components/organisms/PendingSession/PendingSession.store";

export function useBackendQuery<TData = any, TVariables = any>(
  ...props: Parameters<typeof useQuery<TData, TVariables>>
): ReturnType<typeof useQuery<TData, TVariables>> {
  const [query, options] = props;
  // Inside a thread, a record's relations carry what the agent drafted there:
  // a query that takes ``pendingSession`` is given the thread's session.
  const pendingSessionId = usePendingSession()?.pendingSessionId ?? null;
  const takesPendingSession =
    getMainDefinition(query).variableDefinitions?.some(
      (definition) => definition.variable.name.value === "pendingSession",
    ) ?? false;
  const response = useQuery<TData, TVariables>(
    query,
    (takesPendingSession && pendingSessionId
      ? {
          ...(options as object),
          variables: {
            pendingSession: pendingSessionId,
            ...(options as { variables?: object } | undefined)?.variables,
          },
        }
      : options) as typeof options,
  );
  const { signOut } = useClerk();
  const data = response.data;
  if ((data as any)?.errors?.authorizationError) {
    signOut();
    localStorage.removeItem("global-store");
  }

  return response;
}
